// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MarkdownBulletListExtended } from '../../../../../ui-v3/src/assets/icons/extended/markdown/markdown-bullet-list.svg?react';
import { createIcons } from '../../Icon';
const MarkdownBulletListIcon = /* @__PURE__ */ createIcons('MarkdownBulletList', {
    extended: MarkdownBulletListExtended
});
MarkdownBulletListIcon.supportedTypes = [
    'extended'
];
MarkdownBulletListIcon.category = 'markdown';
export default MarkdownBulletListIcon;
